import React from "react";
import Support from "../Components/Support/Support";

const SupportPage = () => {
  return (
    <div>
      <Support />
    </div>
  );
};

export default SupportPage;
